import React from 'react';
import './authenticationLoader.css';

export default function AuthenticationLoader() {
    return (
        <div className="loader-data"></div>
    );
}
